function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'react-bootstrap';
import ShareBox from './ShareBox';
import './Article.scss';

var Article = function (_React$Component) {
  _inherits(Article, _React$Component);

  function Article() {
    _classCallCheck(this, Article);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Article.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        title = _props.title,
        content = _props.content,
        image = _props.image,
        vimeo = _props.vimeo,
        provider = _props.provider,
        ownername = _props.ownername,
        link = _props.link;
    return React.createElement('div', {
      className: 'article'
    }, React.createElement(ShareBox, null), React.createElement('p', {
      className: 'articleProvider'
    }, provider), image && !vimeo && React.createElement(Image, {
      src: image,
      responsive: true
    }), vimeo && React.createElement('div', {
      className: 'article--vimeo',
      style: {
        paddingBottom: 100 * vimeo.height / vimeo.width + '%'
      }
    }, React.createElement('iframe', {
      src: 'https://player.vimeo.com/video/' + vimeo.video_id,
      frameBorder: 0,
      allowFullScreen: true
    })), title && title !== 'null' && React.createElement('h3', null, title), React.createElement('div', {
      className: 'content',
      dangerouslySetInnerHTML: {
        __html: content
      }
    }), React.createElement('br', null), React.createElement('div', {
      className: 'ownername',
      dangerouslySetInnerHTML: {
        __html: 'Av: ' + ownername
      }
    }), children && children.length && React.createElement('div', {
      className: 'additionalColumns'
    }, children));
  };

  return Article;
}(React.Component);

export { Article as default };
Article.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.array,
  title: PropTypes.string,
  content: PropTypes.string,
  image: PropTypes.string,
  vimeo: PropTypes.object,
  provider: PropTypes.string,
  ownername: PropTypes.string,
  owner: PropTypes.string,
  link: PropTypes.string
} : {};